import React from 'react';
type ScoreType = 'E' | 'S' | 'G';
interface CircleProgressProps {
  radius: number;
  strokeWidth: number;
  percent: number | null;
  scoreType: ScoreType;
}

const getBackgroundColor = (type: string) => {
  switch (type) {
    case 'E':
      return 'var(--color-success-light)';
    case 'S':
      return 'var(--color-blue-light)';
    case 'G':
      return 'var(--color-policy-orange-light)';
    default:
      return 'var(--color-error)';
  }
};
const getScoreColor = (type: string) => {
  switch (type) {
    case 'E':
      return 'var(--color-planet-green-radial)';
    case 'S':
      return "var(--color-people-blue-radial)";
    case 'G':
      return 'var(--color-policy-orange-radial)';
  }
  // if (score >= 80) return 'var(--color-success)';
  // if (score >= 60) return 'var(--color-policy-orange)';
  // if (score >= 40) return '#f59e0b';
  // return 'var(--color-error)';
};

export const CircleProgress: React.FC<CircleProgressProps> = ({
  radius,
  strokeWidth,
  percent,
  scoreType,
}) => {
  const circumference = 2 * Math.PI * radius;
  const clampedPercent = Math.max(0, Math.min(percent || 0, 100));
  const dashOffset =  circumference * (1 - clampedPercent / 100);
  return (
    <>
      {/* background circle */}
      <circle
        cx="60"
        cy="60"
        r={radius}
        fill="none"
        stroke={getBackgroundColor(scoreType)}
        strokeWidth={strokeWidth}
      />
      {/* progress circle */}
      <circle
        cx="60"
        cy="60"
        r={radius}
        fill="none"
        stroke={getScoreColor(scoreType)}
        strokeWidth={strokeWidth - 2}
        strokeDasharray={circumference}
        strokeDashoffset={dashOffset}
        transform='scale(1, -1) translate(0, -120)'
        // strokeLinecap="round"
      />
    </>
  );
};
